import InstituteDetail from "./InstituteDetail";
export default InstituteDetail;
